<template>
  <div class="issueStyleDetail">
    <div class="titleHeader">
      <span>问题详情</span>
      <a @click="openPreviewing">打开原文件</a>
      <i v-if="userId == rowData.creatorId" class="el-icon-edit-outline" title="修改问题" @click="openEditQue"></i>
      <i v-if="userId == rowData.creatorId" class="el-icon-delete" title="删除问题" @click="openDeleteQue"></i>
      <i class="el-icon-close closeIcon" title="关闭" @click="closePane"></i>
    </div>
    <el-radio-group v-model="detailType" size="small" @change="navType">
      <el-radio-button label="详 情"></el-radio-button>
      <el-radio-button label="评 论"></el-radio-button>
      <el-radio-button label="活 动"></el-radio-button>
    </el-radio-group>
    <div class="detailContent">
      <navdetailVue v-if="detailType == '详 情'" ref="navdetailVue" @update="update" @refresh="refresh"
        @openshowDetail="openshowDetail" />
      <navreplyVue v-if="detailType == '评 论'" ref="navreplyVue" />
      <nvalineVue v-if="detailType == '活 动'" ref="nvalineVue" :row-data="rowData" />
    </div>
  </div>
</template>

<script>
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import navdetailVue from "./navdetail.vue";
import navreplyVue from "./navreply.vue";
import nvalineVue from "./nvaline.vue";
import requestIssueMg from "@/CommonDP/service/question-service";
import { mapState } from "vuex";
export default {
  components: { navdetailVue, navreplyVue, nvalineVue },
  props: {
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      detailType: "详 情"
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.userId
    })
  },
  methods: {
    navType() {
      if (this.detailType == "详 情") {
        this.$refs.navdetailVue.getDetailInit(this.rowData.questionId, this.rowData.prjId, this.rowData.fileId);
      } else if (this.detailType == "评 论") {
        this.$refs.navreplyVue.showCommentInfo(
          3,
          this.rowData.prjId,
          1,
          this.rowData.questionId,
          this.rowData.questionId,
          ""
        );
      }
    },
    openshowDetail() {
      this.$emit("openshowDetail");
    },
    update() {
      this.$emit("update");
    },
    refresh() {
      this.$emit("refresh");
    },
    openPreviewing() {
      this.$store.dispatch("setModelquestionData", this.rowData);
      const { fileList, fileTypeInt, questionId } = this.rowData;
      let folderId, fileVersion, fileType;
      if (fileList.length > 1) {
        folderId = fileList.map((ele) => ele.fileId).join(",");
        fileVersion = fileList.map((ele) => ele.fileVersion).join(",");
        fileType = Number(fileTypeInt);
      } else {
        folderId = fileList[0].fileId;
        fileVersion = fileList[0].fileVersion;
        fileType = Number(fileTypeInt);
      }
      const data = {
        status: "2",
        fileId: folderId,
        versionId: fileVersion,
        parentId: "",
        questionId,
        fileType
      };
      filePreviewV1(data);
    },
    openDeleteQue() {
      this.$confirm("确定删除该条问题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const ids = [this.rowData.questionId];
          const res = await requestIssueMg.DrawingQuestionDelete(ids);
          if (res.result == "0") {
            this.$message.success("删除成功");
            this.$emit("closeRight");
            this.$emit("update");
          }
        })
        .catch(() => {});
    },
    openEditQue() {
      this.$refs.navdetailVue.openEdit();
    },
    closePane() {
      this.$emit("closeRight");
    }
  }
};
</script>

<style lang="scss" scoped>
.issueStyleDetail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  .titleHeader {
    box-sizing: border-box;
    height: 45px;
    padding: 0 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    // border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    > span {
      margin-right: auto;
      font-size: 16px;
      font-weight: 600;
      user-select: none;
    }
    i {
      font-size: 16px;
      margin-right: 10px;
      cursor: pointer;
      user-select: none;
    }
    a {
      font-size: 14px;
      margin-right: 10px;
      color: var(--theme-color);
      font-weight: 600;
      user-select: none;
      cursor: pointer;
    }
  }
  /deep/.el-radio-button__inner {
    padding: 9px 45px;
  }
  .detailContent {
    height: calc(100% - 90px);
    width: 100%;
    overflow: hidden;
  }
}
</style>
